// extracted by mini-css-extract-plugin
export default {"boardContainer":"styles_boardContainer__WpWi4","boardBg":"styles_boardBg__ll9aE","nxBoardSvg":"styles_nxBoardSvg__iBpID","gameFeedContainer":"styles_gameFeedContainer__WbqJp"};